export default __webpack_public_path__ + "static/media/2016.a64c78c0.png";